import {Component, ElementRef, EventEmitter, Input, Output, viewChild} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {FileWidget} from '@core/components/file-widget/file-widget';
import {Select} from '@core/components/select/select';
import {Attachment} from '@core/types';

@Component({
  selector: 'core-employee-form-sections',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    Select,
    FileWidget
  ],
  templateUrl: './employee-form-sections.html',
  styleUrl: './employee-form-sections.scss'
})
export class EmployeeFormSections {
  readonly contractInputRef = viewChild<ElementRef<HTMLInputElement>>('contractInput');
  readonly documentsInputRef = viewChild<ElementRef<HTMLInputElement>>('documentsInput');

  @Input({required: true}) form!: FormGroup;
  @Input() groupOptions: {label: string; value: string | number}[] = [];
  @Input() roleOptions: {label: string; value: string | number}[] = [];
  @Input() showRoleField = true;
  @Input() roleDisabled = false;
  @Input() isLoadingOptions = false;
  @Input() isSubmitting = false;
  @Input() contractFileName = '';
  @Input() pendingAttachments: File[] = [];
  @Input() existingAttachments: Attachment[] = [];
  @Input() showExistingAttachmentActions = true;
  @Input() showDocumentationSection = true;

  @Output() contractSelected = new EventEmitter<File | null>();
  @Output() documentsSelected = new EventEmitter<File[]>();
  @Output() removePendingAttachment = new EventEmitter<number>();
  @Output() downloadExistingAttachment = new EventEmitter<Attachment>();
  @Output() removeExistingAttachment = new EventEmitter<Attachment>();

  openContractPicker() {
    if (this.isSubmitting) return;
    this.contractInputRef()?.nativeElement.click();
  }

  openDocumentsPicker() {
    if (this.isSubmitting) return;
    this.documentsInputRef()?.nativeElement.click();
  }

  handleContractSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    this.contractSelected.emit(input.files?.[0] || null);
    input.value = '';
  }

  handleDocumentsSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const files = Array.from(input.files || []);
    if (files.length) {
      this.documentsSelected.emit(files);
    }
    input.value = '';
  }

  formatFileSize(size?: number) {
    const bytes = Number(size || 0);
    return `${(bytes / 1024).toFixed(2)} KB`;
  }
}
